import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "EventList",
    component: () => (__SERVER__ ? require("./event-list-view") : import("./event-list-view"))
});

export default definition;
